import React from 'react';
import { observer } from 'mobx-react-lite';
import { withStyles } from '@mui/styles';
import Dialog from 'libraries/Dialog';
import Button from '@mui/material/Button';

const styles = () => ({
    submitButton: {
        minWidth: 124,
        paddingLeft: 45,
        paddingRight: 45
    },
    cancelButton: {
        fontWeight: 700,
        paddingLeft: 30,
        paddingRight: 30
    },
    textWrapper: {
        padding: '20px 0',
        lineHeight: '24px'
    }
});

const ExploreDialog = observer(({
    handleClose, classes, open, goToLibrary
}) => (
    <Dialog
        open={open}
        maxWidth="sm"
        onClose={handleClose}
        titleComponent="Not quite what you're looking for?"
        handleClose={handleClose}
        actionComponent={(
                <>
                    <Button
                        className={classes.closeButton}
                        onClick={handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={goToLibrary}
                        className={classes.submitButton}
                    >
                        View Library
                    </Button>
                </>
        )}
    >
        <div className={classes.textWrapper}>
            <div>Explore our library of ready-made assessments or create your own.</div>
            <b>Note: Closing this preview will result in losing your assessment.</b>
        </div>
    </Dialog>
));

export default withStyles(styles)(ExploreDialog);
